import React from "react";
import { Autocomplete, styled, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { Form } from "react-bootstrap";

const CustomPopper = styled("div")({
  "& .MuiAutocomplete-listbox": {
    backgroundColor: "#2c2c2c", // Dark dropdown background
    color: "#f1f1f1", // Light text color for visibility
  },
  "& .MuiAutocomplete-option": {
    backgroundColor: "#2c2c2c", // Default option background
    color: "#f1f1f1", // Light text color
    '&[aria-selected="true"]': {
      backgroundColor: "#f2674a", // Selected option background (your primary color)
      color: "#fff", // Selected text color
    },
    "&:hover": {
      backgroundColor: "#3d3d3d", // Hover background
      color: "#f1f1f1", // Hover text color
    },
  },
  "& .MuiAutocomplete-noOptions": {
    backgroundColor: "#2c2c2c", // Dark background for no options
    color: "#f1f1f1", // Light text color for visibility
    padding: "12px 16px",
  },
  "& .MuiAutocomplete-loading": {
    backgroundColor: "#2c2c2c", // Dark background for loading
    color: "#f1f1f1", // Light text color for visibility
    padding: "12px 16px",
  },
});

const AutocompleteInput = ({
  name,
  control,
  label,
  defaultValue,
  rules = { required: false },
  customError = null,
  renderInputProps = {},
  externalError = null,
  labelIcon = null,
  TooltipTex = "",
  disableClearable = false,
  onChangeCallback = () => { },
  paperBgColor = "#f2f2f2",
  loading = false,
  loadingText = "Loading...",
  noOptionsText = "No options",
  filterOptions,
  onInputChange,
  ...otherProps
}) => {
  return (
    <>
      {label && <Form.Label>{label}</Form.Label>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({
          field: { onChange, value = null },
          fieldState: { error },
        }) => {
          return (
            <Autocomplete
              id={name}
              fullWidth
              size="small"
              value={value}
              loading={loading}
              loadingText={loadingText}
              noOptionsText={noOptionsText}
              filterOptions={filterOptions}
              onInputChange={onInputChange}
              onChange={(_, value, reason) => {
                onChange(value);
                onChangeCallback(_, value, reason);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  {...renderInputProps}
                  variant="outlined"
                  error={!!error || !!externalError}
                  helperText={error ? error.message : externalError || null}
                  multiline
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      color: '#f1f1f1', // Light text color
                      '& .MuiInputBase-input': {
                        color: '#f1f1f1', // Input text color
                      },
                      '& .MuiInputBase-input::placeholder': {
                        color: '#898989', // Placeholder color
                        opacity: 1,
                      },
                    },
                  }}
                />
              )}
              PaperComponent={(props) => <CustomPopper {...props} />}
              sx={{
                "& .MuiAutocomplete-popupIndicator": {
                  color: "#f1f1f1 !important",
                },
                "& .MuiAutocomplete-clearIndicator": {
                  color: "#f1f1f1 !important",
                },
                "& .MuiOutlinedInput-root": {
                  color: "#f1f1f1", // Text color in input
                  "& fieldset": {
                    borderColor: "#898989", // Border color
                  },
                  "&:hover fieldset": {
                    borderColor: "#f2674a", // Hover border color
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#f2674a", // Focused border color
                  },
                },
              }}
              disableClearable={disableClearable}
              {...otherProps}
            />
          );
        }}
      />
    </>
  );
};

export default AutocompleteInput;